import React from 'react';

const LogoFooterPrint = () => (
  <footer className="px-3 pt-2 pb-5 d-flex justify-content-around align-items-center w-100">
    <img src="/img/footer-2023.png" alt="RNP - CITRA - IARA - MCTI" loading="lazy" className="w-100" />
  </footer>
);

export default LogoFooterPrint;
